<template>
  <div id="app">
    <router-view/>
    <AnotherPlaces></AnotherPlaces>
    <footer class="m-4">
      <p class="text-center text-info mx-auto">Сделано в BAVS</p>
    </footer>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import AnotherPlaces from "@/components/AnotherPlaces";

export default {
  name: "app",
  components: { AnotherPlaces }
};
</script>

<style lang="scss">
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
